import { SentimentWordConfig } from './types';

export const plSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'aktywny',
        'bezpieczny',
        'dobry',
        'doskonaly',
        'gotowy',
        'jasny',
        'kompletny',
        'mocny',
        'nadzieja',
        'naprawiony',
        'optymistyczny',
        'pewny',
        'pozytywny',
        'postep',
        'pomocny',
        'poprawa',
        'poprawiony',
        'rozwiazany',
        'rozwoj',
        'silny',
        'spokojny',
        'stabilny',
        'sukces',
        'szczesliwy',
        'uzyteczny',
        'wartosciowy',
        'wygrana',
        'wzrost',
        'zdrowy',
        'zwyciestwo',
        'akceptacja',
        'bezpiecznie',
        'cenny',
        'czysty',
        'doceniony',
        'dobrze',
        'energiczny',
        'inspirujacy',
        'jasno',
        'korzysc',
        'latwy',
        'lepszy',
        'lubiany',
        'mily',
        'naprawa',
        'niezawodny',
        'odwaga',
        'opieka',
        'osiagniety',
        'radosc',
        'satysfakcja',
        'sprawny',
        'udany',
        'ulga',
        'uporzadkowany',
        'wsparcie',
        'zaufanie',
        'zysk',
        'pogodny',
        'moc',
        'aktywnie',
        'ambitny',
        'bezpieczenstwo',
        'blask',
        'brawo',
        'cieply',
        'dobro',
        'duma',
        'elastyczny',
        'harmonia',
        'jasnosc',
        'komfort',
        'korzystny',
        'lagodny',
        'lekki',
        'milosc',
        'mocno',
        'naped',
        'odprezony',
        'odporny',
        'ogarniety',
        'optymizm',
        'pewnosc',
        'pochwala',
        'pogoda',
        'pomyslny',
        'porzadek',
        'przyjazny',
        'radosny',
        'ratunek',
        'satysfakcjonujacy',
        'serdeczny',
        'sprawdzony',
        'spokoj',
        'szacunek',
        'udalo',
        'umocniony',
        'wygoda',
        'wdzieczny',
        'wytrwaly',
    ]),
    negativeWords: new Set([
        'awaria',
        'blad',
        'blokada',
        'bol',
        'chaos',
        'katastrofa',
        'kryzys',
        'niebezpieczny',
        'niepewny',
        'negatywny',
        'nienawisc',
        'opozniony',
        'opoznienie',
        'pilny',
        'problem',
        'regresja',
        'ryzyko',
        'slaby',
        'smutny',
        'straszny',
        'trudny',
        'utkniety',
        'wadliwy',
        'wolny',
        'zagrozenie',
        'zepsuty',
        'zly',
        'zmartwiony',
        'agresja',
        'alarm',
        'awaryjny',
        'chaotyczny',
        'ciezki',
        'fatalny',
        'frustrujacy',
        'grozny',
        'krytyczny',
        'martwy',
        'niepokoj',
        'niestabilny',
        'obawa',
        'panika',
        'porazka',
        'presja',
        'przeszkoda',
        'przytloczony',
        'smutek',
        'spiecie',
        'stres',
        'szkoda',
        'toksyczny',
        'tragiczny',
        'utkniecie',
        'utrata',
        'wkurzony',
        'wstyd',
        'wyczerpany',
        'zagrozony',
        'zalamanie',
        'zator',
        'zepsucie',
        'zle',
        'zmeczony',
        'zwloka',
        'porażka',
        'alarmowy',
        'atak',
        'awantura',
        'bolesny',
        'brzydki',
        'chaotycznosc',
        'cios',
        'ciezar',
        'depresja',
        'denerwujacy',
        'dotkliwy',
        'dramat',
        'groza',
        'irytujacy',
        'katastrofalny',
        'klopot',
        'konflikt',
        'nieprzyjemny',
        'niewygoda',
        'obrzydliwy',
        'opresja',
        'oslabiony',
        'paniczny',
        'potkniecie',
        'presyjny',
        'przykry',
        'rozpad',
        'smiertelny',
        'stresujacy',
        'toksycznosc',
        'tragedia',
        'uciazliwy',
        'wina',
        'wrogi',
        'zalosny',
    ]),
};
